/* Sendbird's default styling (see: node_modules/@sendbird/uikit-react/dist/index.css)
 * includes a border:1px on all four sides. On web, the TabBar being on the top of the
 * screen results in a double-border on the app/(app)/(tabs)/messages/group-channel screen.
 * This overrides the entire border to 0 to resolve this problem, and improve the UI/UX.
 */
.sendbird-theme--light .sendbird-conversation,
.sendbird-theme--dark .sendbird-conversation {
  border: 0;
}
.sendbird-og-message-item-body__og-thumbnail {
  display: none !important;
}
